export default __webpack_public_path__ + "static/media/otpview.21d8d496.png";